import React from 'react';
import KeyValueInput from './KeyValueInput';

const KeyValueInputGroup = ({ name, keyLabel, valueLabel, group, options, onDelete, onKeyValueInput }) =>
    group.map((item, index) => (
        <KeyValueInput
            name={name}
            onKeyValueInput={onKeyValueInput}
            key={index}
            index={index}
            keyValue={item.k}
            keyOptions={options}
            valueValue={item.v}
            keyLabel={keyLabel}
            valueLabel={valueLabel}
            onDelete={onDelete}
        />
    ));

export default KeyValueInputGroup;



// WEBPACK FOOTER //
// ./src/components/forms/KeyValueInputGroup.js